import {SubscriptionChargesFragment} from '../../../../gql/graphql';
import {LineItemModel} from '../LineItems/LineItem.model';

export class SubscriptionChargeModel {
  public lineItemName: string;
  public description: string;

  constructor(params: SubscriptionChargeModel) {
    this.lineItemName = params.lineItemName;
    this.description = params.description;
  }

  public static fromCheckoutV1(lineItems: LineItemModel[], subscriptionCharge?: SubscriptionChargesFragment | null) {
    if (!subscriptionCharge?.description || !subscriptionCharge.lineItemIds) {
      return undefined;
    }

    const lineItemName = lineItems.find((lineItem) => lineItem.id === subscriptionCharge.lineItemIds?.[0])?.name ?? '';

    return new SubscriptionChargeModel({
      lineItemName,
      description: subscriptionCharge.description,
    });
  }
}
